module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Extrabld.ba694cf253c59860163f20370b09a908.eot";